import { render, staticRenderFns } from "./RevAccountEdit.vue?vue&type=template&id=665ecaa8"
import script from "./RevAccountEdit.vue?vue&type=script&lang=ts"
export * from "./RevAccountEdit.vue?vue&type=script&lang=ts"
import style0 from "./RevAccountEdit.vue?vue&type=style&index=0&id=665ecaa8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports